import { render, staticRenderFns } from "./NarrowDown.vue?vue&type=template&id=06103aa4&scoped=true"
import script from "./NarrowDown.vue?vue&type=script&lang=js"
export * from "./NarrowDown.vue?vue&type=script&lang=js"
import style0 from "./NarrowDown.vue?vue&type=style&index=0&id=06103aa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06103aa4",
  null
  
)

export default component.exports